<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<template>
	<footer class="bg-gray-100 border-t border-gray-200 py-4 px-6 text-center text-sm text-gray-500">
		<span>© 2026 Badminton Americano</span>
		<span class="mx-2">·</span>
		<RouterLink to="/privacy" class="hover:text-gray-700 underline">{{ t('privacy.title') }}</RouterLink>
		<span class="mx-2">·</span>
		<RouterLink to="/terms" class="hover:text-gray-700 underline">{{ t('terms.title') }}</RouterLink>
	</footer>
</template>
